import { render, staticRenderFns } from "./updatePWD.vue?vue&type=template&id=8c3309f2&scoped=true"
import script from "./updatePWD.vue?vue&type=script&lang=js"
export * from "./updatePWD.vue?vue&type=script&lang=js"
import style0 from "./updatePWD.vue?vue&type=style&index=0&id=8c3309f2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c3309f2",
  null
  
)

export default component.exports